<template lang="html">
  <div class="fill-height">
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.phone_number_verification') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="bg-verification mb-4">
            <div class="col-verification">
              <img v-if="(form.otp_type === 3)" src="@/assets/images/v2/img/whatsapp.png" alt="whatsapp">
              <img v-else-if="(form.otp_type === 1)" src="@/assets/images/v2/img/message.png" alt="message">
            </div>
          </div>
          <div class="font-18 font-weight-700 mb-2">
            {{ $t('v2.enter_otp_code') }}
          </div>
          <div class="subtext mb-8">
            <span v-if="(form.otp_type === 3)">
              {{ $t('v2.otp_has_been_sent_wa', { phone: form.phone }) }}
            </span>
            <span v-else-if="(form.otp_type === 1)">
              {{ $t('v2.otp_has_been_sent_sms', { phone: form.phone }) }}
            </span>
          </div>
          <div class="mb-6">
            <CodeInput v-if="(form.otp_type === 3)" key="otpwa" :loading="false" :fields="6" :auto-focus="true" :field-width="46" :field-height="46" :class="['input inputVerificationCode', { 'input-otp-err': hasError }]" @change="onChangeOtp" @complete="onCompleteOtp" />
            <CodeInput v-else-if="(form.otp_type === 1)" key="otpsms" :loading="false" :fields="5" :auto-focus="true" :field-width="46" :field-height="46" :class="['input inputVerificationCode', { 'input-otp-err': hasError }]" @change="onChangeOtp" @complete="onCompleteOtp" />
            <div v-if="hasError" class="mt-1 phone-has-error">
              {{ message_error }}
            </div>
          </div>
          <div v-if="formattedTimeLeft !== 'EXPIRED'" class="text-center">
            {{ $t('v2.resend_code') }} ({{ formattedTimeLeft }})
          </div>
          <template v-else>
            <div class="text-center ol-brand font-weight-700 cursor-pointer" @click="resendOTP()">
              {{ $t('v2.resend_code') }}
            </div>
            <div class="text-center ol-brand font-weight-700 cursor-pointer mt-8" @click="resendOTP(true)">
              {{ $t('v2.verify_using') }}
              <span v-if="(form.otp_type === 3)">SMS</span>
              <span v-else-if="(form.otp_type === 1)">Whatsapp</span>
            </div>
          </template>
        </v-col>
      </v-row>
    </v-container>
    <v-bottom-sheet v-model="dialog.limit_resend" content-class="dialog-icon">
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="mt-12 text-center mb-10">
                <img src="@/assets/images/v2/img/limit_resend.png" alt="Limit">
              </div>
              <div class="text-center">
                <div class="font-18 font-weight-700 ol-black mb-4">
                  {{ $t('v2.verification_reached_limit') }}
                </div>
                <div class="font-14 font-weight-400 ol-black mb-10" v-html="$t('v2.you_have_verified_several_times', { time: formatTimeLimit })" />
                <v-btn block color="white" class="br-5 text-none ol-elevation-1 font-weight-700 letter-spacing-normal" @click="dialog.limit_resend = false">
                  {{ $t('v2.cancel2') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import {
  requestOTP,
  verifyOTPv2
} from '@/api/auth'
export default {
  data() {
    return {
      dialog: {
        limit_resend: false
      },
      limit_time: 0,
      limitInterval: null,
      hasError: false,
      message_error: '',
      form: {
        phone: '',
        otp_type: ''
      },
      form_verify: {
        phone: '',
        otp_code: ''
      },
      expired_time: 0,
      timerInterval: null
    }
  },
  computed: {
    formatTimeLimit() {
      let days = Math.floor(this.limit_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.limit_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.limit_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.limit_time % (1000 * 60)) / 1000)
      let result
      if (this.limit_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ':' : hours + ':'
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    },
    formattedTimeLeft() {
      let days = Math.floor(this.expired_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.expired_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.expired_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.expired_time % (1000 * 60)) / 1000)
      let result
      if (this.expired_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ':' : hours + ':'
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    }
  },
  watch: {
    formatTimeLimit: function(newItem) {
      if (newItem === 'EXPIRED' || newItem === '00:00') {
        this.dialog.limit_resend = false
      }
    }
  },
  created() {
    if (typeof this.$route.query.phone !== 'undefined' && this.$route.query.phone && typeof this.$route.query.expiry_date !== 'undefined' && this.$route.query.expiry_date) {
      this.form.phone = this.$route.query.phone
      this.form.otp_type = Number(this.$route.query.otp_type)
      this.getExpiryTime(this.$route.query.expiry_date)
    } else {
      this.$router.push({ name: '_phone_check', query: { redirect: this.$route.query.redirect }}).catch(() => {})
    }
  },
  methods: {
    goBack() {
      if (!this.$isEmpty(this.$route.query) && typeof this.$route.query.redirect !== 'undefined') {
        this.$router.push({ name: '_phone_check', query: { redirect: this.$route.query.redirect }}).catch(() => {})
      } else {
        this.$router.push({ name: '_phone_check' }).catch(() => {})
      }
    },
    onChangeOtp(v) {
      this.hasError = false
    },
    async onCompleteOtp(v) {
      this.hasError = false
      this.form_verify.otp_code = v
      try {
        this.form_verify.phone = this.form.phone
        const { data } = await verifyOTPv2(this.form_verify)
        this.$store.dispatch('save_token', data)
        this.$router.push({ name: '_account', query: { redirect: this.$route.query.redirect }}).catch(() => {})
      } catch (e) {
        this.message_error = e.message
        this.hasError = true
      }
    },
    getExpiryTime(time) {
      const countDownDate = new Date(new Date(time).getTime() - 1 * 60000)
      const _this = this
      this.timerInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.expired_time = countDownDate - now
        if (_this.expired_time < 0) {
          clearInterval(_this.timerInterval)
        }
      }, 1000)
    },
    async resendOTP(is_change = false) {
      if (is_change) {
        let otp_type
        if (this.form.otp_type === 3) {
          otp_type = 1
        } else if (this.form.otp_type === 1) {
          otp_type = 3
        }
        this.form.otp_type = otp_type
      }
      try {
        const { data } = await requestOTP(this.form)
        const time = data.data.detail.expiry_date
        this.$router.push({ name: '_verification', query: { redirect: this.$route.query.redirect, otp_type: this.form.otp_type, phone: this.form.phone, expiry_date: time }}).catch(() => {})
        this.getExpiryTime(time)
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.code_sent_successfully')
        this.$store.state.error_type = 200
      } catch (e) {
        if (e.statusCode === 429) {
          this.dialog.limit_resend = true
          this.getLimitTime(e.data.unlocked_in)
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    getLimitTime(time) {
      const countDownDate = new Date(time).getTime()
      const _this = this
      this.limitInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.limit_time = countDownDate - now
        if (_this.limit_time < 0) {
          clearInterval(_this.limitInterval)
        }
      }, 1000)
    }
  }
}
</script>
